import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem, Col, Button, FormGroup, Row } from "reactstrap";
import * as actionCreators from '../../../../modules/actions/index';
import * as url from '../../../../utils/url';
import { connect } from "react-redux";
import axios from '../../../../axios';
import {addToolStep, create_event_hosts, toolkitFields} from '../../../../utils/constants';
import {addToolDetailsInForm} from '../../../../utils/createRequestData';
import { toolkitCategories, initialToolDetailsState } from '../../../../utils/categories';
import DetailsSection from "../Sections/DetailsSection/DetailsSection";
import MoreSection from "../Sections/MoreSection/MoreSection";
import HeaderSection from "../Sections/HeaderSection/HeaderSection";
import CommentsSection from "../Sections/CommentsSection/CommentsSection";
import pick from 'lodash/pick';
import { deepClone } from "../../../../utils/copyObject";


class ToolPreview extends Component {
  constructor(props) {
    super(props);
     this.state = {
      isSubmitted: false
    }
  }

  componentWillReceiveProps(nextProps) {
    // If condition to navigate to toolkit category page after successfull toolkit creation
    // if(nextProps.toolDetails.nextStep === '') {
    //   let link = '';
    //   for(let category of toolkitCategories) {
    //     if(category.name === nextProps.toolDetails.category) {
    //       link = category.link;
    //     }
    //   }
    //   this.props.history.replace('/home/toolkit/'+ link);
    // } 
    // If condition to navigate to info step of add tool
    let {toolDetails} = nextProps
    const category = this.props.match.params.category;
    if (toolDetails.nextStep === addToolStep.info && toolDetails._id && toolDetails._id!=='') {
      this.props.history.replace(`/home/toolkit/${category}/edit/${toolDetails._id}`);
    } else if(toolDetails && toolDetails.nextStep === addToolStep.info) {
      this.props.history.replace(`/home/toolkit/${category}/add`);
    }  
}


  componentDidMount() {
    const category = this.props.match.params.category;
    
    // const unblock = this.props.history.block((location, action) => {
    //   let {isSubmitted}=this.state
    //   if (!location.pathname.startsWith(`/home/toolkit/${category}/tool`) && !location.pathname.startsWith(`/home/toolkit/${category}/edit`) && location.pathname!==`/home/toolkit/${category}/preview` && location.pathname !==`/home/toolkit/${category}/add` && isSubmitted!==true) return "You have not completed the process yet. Are you sure you want to leave without completing it?";
    //   if (action==='POP' && isSubmitted!==true) return "You have not completed the process yet. Are you sure you want to leave without completing it?";
    //  }); 

    // const unlisten = this.props.history.listen((location, action) => {
    //   // location is an object like window.location
    //   // console.log(action, location.pathname, location.state);
    //   if (!location.pathname.startsWith(`/home/toolkit/${category}/edit`) && location.pathname !==`/home/toolkit/${category}/preview` && location.pathname !==`/home/toolkit/${category}/add`) {
    //     unblock();
    //     unlisten();
    //     this.props.onLeavePreviewTool();
    //   }
   

    // })
  }

  backToEdit = () => {
    // this.props.onGoBackPressed({nextStep: addToolStep.privacy,});
    const {category} = this.props.match.params
    this.props.onToolBackToEditPressed({nextStep: addToolStep.privacy, isPrivacySettingsChanged: false});
    if(this.props.toolDetails && this.props.toolDetails._id){
    this.props.history.replace(`/home/toolkit/${category}/edit/${this.props.toolDetails._id}`);
    } else {
      this.props.history.replace(`/home/toolkit/${category}/add`);
    }
  }

  submitTool = () => {
    // this.props.onToolPrivacySettingsCompleted({nextStep: addToolStep.privacy, ...privacy});
    if(this.props.toolDetails && this.props.toolDetails._id){
      console.log('edit---')
      
      this.handleEditTool();
    } else {
      console.log('create----')
      this.handleCreateTool();
    }
  }

  handleCreateTool = () => {
    let toolDetails = deepClone({...this.props.toolDetails});
    delete toolDetails._id;
    let{user}=this.props, {groupEvent}=user
    let groupUrl=null
        let formData = new FormData();
    
    if(groupEvent&&groupEvent.groupId){
      groupUrl = `/home/groups/${user.organizationId._id}/view/${groupEvent.groupId}/events`
      toolDetails = {...toolDetails, groupId: groupEvent.groupId}
    }

    if((!toolDetails.hasOwnProperty('_id') || toolDetails.hasOwnProperty('_id')==null) && toolDetails.category==='Conferences & Events'){

      let event_owner = create_event_hosts(user, user,toolDetails, groupEvent )
        let{invitees}= toolDetails
        toolDetails = {...toolDetails, invitees:[...invitees,event_owner ]}
    } 



    if(toolDetails&& toolDetails.invitedUsers && toolDetails.invitedUsers.length>0 &&  toolDetails.category==='Conferences & Events'){
      let{invitedUsers}=toolDetails
        let host_arr = invitedUsers.map(host=> {
          host={...host, _id: host.value}
          console.log('host---- ', host)
          return create_event_hosts(user, host, toolDetails, groupEvent )
        })
        let{invitees}= toolDetails

      toolDetails = {...toolDetails, invitees:[...invitees, ...host_arr ]}
    }
    formData = addToolDetailsInForm(formData, toolDetails);
    formData.append('payload', JSON.stringify(toolDetails))
    axios.post(url.addTool, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const category = this.props.match.params.category;
      this.props.onAddToolSuccess({...initialToolDetailsState, category: this.props.toolDetails.category, isPrivacySettingsChanged: false});

      this.props.history.replace(`/home/toolkit/${category}/tool/${response.data._id}`);
    }).catch(error => {
       console.log(error);
    });
  }

  handleEditTool = () => {
    let {toolDetails} = this.props;


    let {category} = toolDetails


    let link = '';
    for(let cat of toolkitCategories) {
      if(category === cat.name) {
        link = cat.link;
      }
    }
    this.setState({isSubmitted:true})

    let formData = new FormData();
    let that = this
    formData = addToolDetailsInForm(formData, toolDetails);
    formData.append('payload', JSON.stringify(toolDetails))
    // return
    axios.put(url.editTool(toolDetails._id), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      this.props.onLeavePreviewTool();
      this.props.history.replace(`/home/toolkit/${link}/tool/${toolDetails._id}`);

    }).catch(error => {
       console.log(error);
    });
  }

  navigateToToolkitategory = () => {
      let link = '';
      for(let category of toolkitCategories) {
        if(category.name === this.props.toolDetails.category) {
          link = category.link;
        }
      }
      this.props.history.replace('/home/toolkit/'+ link);
  }

  render() {
    return (
      <span className="tool_details_preview_container">
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <a className="navigate-to-category-link" onClick={this.navigateToToolkitategory}>Toolkit: {this.props.toolDetails.category}</a>
            </BreadcrumbItem>
            <BreadcrumbItem active className="create-chart-active-category">{this.props.toolDetails.name}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <Row className="mt30">
          <HeaderSection {...this.props} preview={true} />
        </Row>
        <Row className="mt30 col-sm-12 tool_details_preview_container_details">
          <Col sm={8}>
            <DetailsSection toolDetails={this.props.toolDetails} />
          </Col>
          <Col sm={4} className="pr0">
            <div><MoreSection toolDetails={this.props.toolDetails} editTool={this.backToEdit} preview={true}/></div>
            <div className="mt30">
              <CommentsSection toolDetails={this.props.toolDetails} preview={true}/></div>
          </Col>
        </Row>
        <Row className="mb20 mt40" style={{marginRight:'-30px'}}>
        <Col sm={{size: 3, offset: 6}} md={{size: 3, offset: 6}}>
            <Button
              className="float-right goBackBtn w100"
              onClick={this.backToEdit}
            >
              <span className="goBackBtnTxt">
                <span className="mr10 flaticon-back"> Back To Edit </span><span />
              </span>
            </Button>
          </Col>
          <Col sm="3" md="3">
            <Button
              className="float-right continueBtn w100"
              onClick={this.submitTool}
            >
              <span className="continueBtnTxt">Submit <span className="ml10 flaticon-tick"></span></span>
            </Button>
          </Col>
        {/* <Col sm={{size: 12}}>
              <Button
                className="float-right continueBtn ml10"
                onClick={this.submitTool}
              >
                <span className="continueBtnTxt">Submit <span className="ml10 flaticon-tick"></span></span>
              </Button>
              <Button
                className="float-right goBackBtn"
                onClick={this.backToEdit}
              >
                <span className="goBackBtnTxt text center">
                <span className="mr10 flaticon-back"> Back To Edit </span><span />
                </span>
              </Button>
            </Col> */}
        </Row>  
        </span>  
    );
  }
}

const mapStateToProps = state => {
  return {
    toolDetails: state.toolkit.toolDetails,
    user: state.user.profile
  };
};

const mapDispatchToProps = dispatch => {
	return {
    onToolBackToEditPressed: (data) => dispatch(actionCreators.addToolBackToEdit(data)),
    onAddToolSuccess: (data) => dispatch(actionCreators.addToolSuccess(data)),
    onEditToolSuccess: (data) => dispatch(actionCreators.editToolSuccess(data)),
    onGoBackPressed: (data) => dispatch(actionCreators.toolGoBackPressed(data)),

    onLeavePreviewTool: () => dispatch(actionCreators.leavePreviewTool())
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ToolPreview);
